import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, ListItem } from 'material-ui';

import TcDayPicker from '../../../tc-ui/date-picker';

const { object, string } = PropTypes;

const ListFilter = ({ filterKey, onFilterChange, selectedValue, title, value }) => {
  const splitted = (selectedValue || '').split('|');
  const fromDate = splitted[0];
  const toDate = splitted[1];
  return (
    <ListItem
      primaryText={title}
      insetChildren
      leftCheckbox={
        <Checkbox
          disabled={!Boolean(selectedValue)}
          value={`${filterKey}::${value}`}
          checked={Boolean(selectedValue)}
          onCheck={() => onFilterChange('')}
        />
      }
      primaryTogglesNestedList
      nestedListStyle={{ textAlign: 'center' }}
      nestedItems={[
        <div key={0} className="flex-tc-sb">
          <TcDayPicker
            data-cy="fromDate"
            textFieldStyle={{ width: '100%', fontSize: '12px' }}
            onChange={(date) => onFilterChange(`${date}|${toDate || date}`)}
            value={fromDate}
            initialMonth={fromDate || toDate}
            floatingLabelText="From Date"
            closeOnSelect
          />
          <TcDayPicker
            data-cy="toDate"
            textFieldStyle={{ width: '100%', fontSize: '12px' }}
            onChange={(date) => onFilterChange(`${fromDate || date}|${date}`)}
            value={toDate}
            enableFrom={fromDate}
            initialMonth={toDate || fromDate}
            floatingLabelText="To Date"
            closeOnSelect
          />
        </div>]
      }
    />
  );
};

ListFilter.propTypes = {
  filter: object,
  selectedValue: string,
};

export default ListFilter;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/includingPeriod.jsx